import React from "react";
import { TextWithDividerLine } from "@qgiv/core-donor";
import ConnectedPayPalSDKScriptProvider from "./ConnectedPayPalSDKScriptProvider";
import ConnectedPayPalAuthenticatedMessage from "./ConnectedPayPalAuthenticatedMessage";
import ConnectedUpdateShouldReauthorizePayPal from "./ConnectedUpdateShouldReauthorizePayPal";

/**
 * @param {object} props
 * @param {boolean} props.displayPayPal
 * @param {boolean} props.displayPayPalAuthenticatedMessage
 * @param {boolean} props.displayPayPalSDKScriptProvider
 * @returns {React.ReactElement|null}
 */
const OnePayPayPal = ({
    displayPayPal,
    displayPayPalAuthenticatedMessage,
    displayPayPalSDKScriptProvider,
}) =>
    displayPayPal ? (
        <>
            <div className="-callout qg-vendor-digital-wallet-container">
                <div>
                    {displayPayPalSDKScriptProvider && (
                        <div className="qg-vendor-paypal-venmo-buttons">
                            <ConnectedPayPalSDKScriptProvider />
                        </div>
                    )}
                    {displayPayPalAuthenticatedMessage && (
                        <>
                            <ConnectedPayPalAuthenticatedMessage />
                            <ConnectedUpdateShouldReauthorizePayPal />
                        </>
                    )}
                </div>
            </div>
            <div className="qg-vendor-digital-wallet-divider">
                <TextWithDividerLine text="or" />
            </div>
        </>
    ) : null;

export default OnePayPayPal;
